<div class="header">
  <h2>{{ headerText }}</h2>
  <p>{{ subHeaderText }}</p>
</div>
